import React, {useState} from "react";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import SearchTable from "../../../primer/Search-Table";

const SearchReferrals = () => {
    const searchFilters = {
        filters: [
            {
                name: "amka",
                label: "ΑΜΚΑ Ασθενή",
                type: "input",
            },
        ],
        actions: [],
    }

    const searchColumns = [
        {
            name: "Αρ. Παραπεμπτικού",
            field: "barcode",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Κατηγορία Εξέτασης",
            field: "examinationGroupName",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Αναγνωριστικό Ασθενή",
            field: "identifier",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ονοματεπώνυμο",
            field: "name",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ασφαλιστικός Φορέας",
            field: "socialInsurance",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Ημ/νια έκδοσης",
            field: "issueDate",
            editable: false,
            inputType: {
                type: "text",
            }
        },
        {
            name: "Κατάσταση",
            field: "status",
            editable: false,
            inputType: {
                type: "text",
            }
        },
    ]

    const [tableColumns, setTableColumns] = useState(searchColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName={"Prescription Search Referrals"}
                key={"Prescription Search Referrals"}
                hideYearFilter={false}
                allowOtherYears={true}
                allowPagination={true}
                allowToggleColumns={true}
                showDummyData={false}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                allowSelectionCheckbox={false}
                data={[]}
                filtersConfig={searchFilters}

                allowSorting={false}
                allowPrintResults={true}
                dataEndpoint={"/prescription/export-referrals"}
                exportFileName={"Παραπεμπτικά"}
            />
        </div>
    )
}

export default SearchReferrals
